import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
    userId: "",
}

export const projectTeamMemberData = {
    name: "Project Team Member selectore",
    initialState: initState,

    section: [
        {
            sectionId: 'TeamMember',
            title: "Project Team Member selectore Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-6",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "userId",
                    label: "Team Member",
                    Field_Name: "team member",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "userId",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Team Member",
                        allowSpace: true,
                        isMultiSelect: true,
                        options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-6 mb-2 validation-left-0",
                    },
                },
            ]
        }
    ]
};
